export const SELECT_DROPDOWN_LIST_SEARCH_INPUT_HEIGHT = 40
